<template>
    <div id="myths-busters">
        <section class="special-area bg-white section_padding" id="about">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="section-heading text-center">
                            <h2>{{ $t('בחיאת... אנחנו ב-2021') }}</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="single-special wow fadeInUp" :class="{'single-special-en': language === 'en'}" data-aos="fade-up" data-aos-duration="1200">
                            <div class="single-icon text-center">
                                <i class="fas fa-mobile"></i>
                            </div>
                            <h4 class="text-center">{{ $t('אצלנו כל אתר רספונסיבי') }}</h4>
                            <p>{{ $t('זאת העבודה שלנו לדעת ש 80% מהכניסות למערכת העתידית שלכם יהיו מהטלפון הנייד.') }}</p>
                            <p>{{ $t('לנו ב-Productive Labs יש סטנדרטים, ולכן כל מוצר שמפותח אצלנו הוא רספונסיבי ומותאם קודם כל לנייד וללא תוספת במחיר!') }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="single-special wow fadeInUp" :class="{'single-special-en': language === 'en'}" data-aos="fade-up" data-aos-duration="1200">
                            <div class="single-icon text-center">
                                <i class="far fa-lightbulb"></i>
                            </div>
                            <h4 class="text-center">{{ $t('בעצם אל תקראו לי אתר') }}</h4>
                            <p>{{ $t('אנחנו לא בונים אתרים, אנחנו מפתחים אפליקציות Web.') }}</p>
                            <p>{{ $t('אי אפשר לפספס את ההבדל - זה כבר לא אוסף דפי אינטרנט סטטיים. בזכות שימוש בטכנולוגיות החדשניות ביותר כל מוצר שלנו ירגיש כמו אפליקציה חיה וחכמה שמגיבה ללקוח...') }} <a class="text-muted" v-scroll-to="'#rich-client'">{{ $t('קראו עוד') }}</a></p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="single-special wow fadeInUp" :class="{'single-special-en': language === 'en'}" data-aos="fade-up" data-aos-duration="1200">
                            <div class="single-icon text-center">
                                <i class="fas fa-bolt"></i>
                            </div>
                            <h4 class="text-center">{{ $t('מהירות מעל הכל') }}</h4>
                            <p>{{ $t('אתם יכולים לשכוח מהמושג טעינה!') }}</p>
                            <p>{{ $t('מבחינתנו מדובר בסטנדרט של חווית משתמש, המערכות שלנו תמיד יגיבו באופן חי ללקוח ושינויים, תזוזות ומעברים בין עמודים ייעשו באופן מהיר ודינמי כשהדפדפן פשוט לא עוצר לחשוב לרגע.') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data (){
            return{
                mobile: window.matchMedia("(max-width:767px)").matches,
            }
        },
        name: 'myths-busters',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
        },
    }
</script>

<style lang="css" scoped>
    .section_padding {
        background-color: #f8f8f8 !important;
        padding-top: 60px;
        padding-bottom: 30px;
    }
    .section-heading {
        margin-bottom: 60px;
    }
    .text-center {
        text-align: center!important;
    }
    .section-heading > h2 {
        font-weight: 300;
        color: #000;
        font-size: 48px;
        margin: 0;
    }
    .section-heading {
        margin-bottom: 60px;
    }
    .single-special {
        border: 1px solid #eff2f6;
        padding: 40px;
        border-radius: 40px 40px 40px 40px;
        -webkit-transition-duration: 800ms;
        -o-transition-duration: 800ms;
        transition-duration: 800ms;
        margin-bottom: 30px;
        background-color: #fff;
    }
    .single-special:hover {
        -webkit-box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
        box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
    }
    .single-icon {
        margin-bottom: 25px;
    }
    .single-special > h4 {
        font-size: 22px;
        color: #000;
        margin-bottom: 15px;
    }
    .single-icon > i {
        font-size: 36px;
        color: #bf35d0;
    }
    .text-muted {
        color: #b1b4b7!important;
        cursor:pointer;
    }
    @media (max-width: 767px) and (min-width: 320px) {
        .section-heading > h2 {
            font-size: 32px;
        }
        .single-special {
            margin-bottom: 30px;
        }
    }
    @media (min-width: 1200px) {
        .single-special {
            min-height: 385px;
        }
        .single-special-en {
            min-height: 435px;
        }
    }
    @media (min-width: 992px) and (max-width: 1199px) {
        .single-special {
            min-height: 520px;
        }
    }
    @media (min-width: 768px) and (max-width: 991px) {
        .single-special {
            min-height: 620px;
        }
    }
</style>
